import Carousel from '../components/Carousel'
import Contact from '../components/Contact'
import Feedbacks from '../components/Feedbacks'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import IdeaSectionAbout from '../section/IdeaSectionAbout'
import ThreeDHero from '../section/ThreeDHero'
import React from 'react'
import PartnersLogos from '../components/PartnersLogos'
import { Helmet } from 'react-helmet';
import IdeaMotionSect from '../section/IdeaMotionSect'


function ThreeDMotion() {
  return (
    <div className="relative z-0 bg-[#060816]">
       <Helmet>
        <title>3D Motions Graphics - The Designsinc.</title>
      </Helmet>
    <div>
      <Navbar />
      <div>
        {/** About Section */}
       <ThreeDHero />
        {/**Slider logos company */}
        <PartnersLogos />

        {/**idea section and btns */}
        <IdeaMotionSect />

        {/** Testimonials */}
        <div className="">
        <Feedbacks  />
        </div>
        {/** contact section */}
        <div className='relative z-0'>
      <Contact />
     
    </div>
      </div>
    </div>

    <Footer />
  </div>
  )
}

export default ThreeDMotion